module.exports = __webpack_public_path__ + "img/comment_3_2.c13fbecf.jpg";